import IAlertService from "../../services/alert/IAlertService";
import {container} from "@/inversify.config";
import {DiTokens} from "../../services/diTokens";
import Vue from "vue";
import {callSignalRMethod, createSignalR, signalREventHandler, startSignalR} from '../../services/api/signalR';
import {AttachmentData, Message, MessageStatus, SenderType} from '../../data/chat';
import {getMessagesAction} from 'fs-pb-vue2/services/chat/chat';

/**
 *  Класс для компоненты чата
 */
export class ChatVue extends Vue {
  months: string[] = ["Января", "Февраля", "Марта", "Апреля", "Мая", "Июня", "Июля", "Августа", "Сентября", "Октября", "Ноября", "Декабря"];
  chatMessages: Array<Message> = []
  connection: any = null;
  newCount: number = 0;
  loading: boolean = true;
  files: []
  fileTypes: []
  attachmentsData: Array<string> = []

  timer: any = null;

  async init(): Promise<void> {
    this.fileTypes = ["jpg", "jpeg", "png", "bmp", "gif"]
    await this.loadMessages()
    if (!this.connection) {
      this.connection = createSignalR("/chat")

      signalREventHandler(this.connection, "ReceiveStatus", (message: Message) => this.receiveStatusEvent(message))
      signalREventHandler(this.connection, "ReceiveMessage", (message: Message) => this.receiveMessageEvent(message))
      startSignalR(this.connection).then(() => {

      }).catch((err) => {
        this.alertService.error(err.toString());
      });
    }
    this.loading = false;
    this.scrollToBottom();
  }

  async attachFile(e) {
    this.files = e.target.files;
    this.attachmentsData = [];
    for (let i = 0; i < this.files.length; i++) {
      if (!this.fileTypes.includes(this.files[i].name.split(".").pop().toLowerCase()) || this.files[i].size > 1048576) {
        continue;
      }

      const content = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(this.files[i]);
        reader.onload = () => resolve(reader.result.toString().substr(reader.result.toString().indexOf(',') + 1));
        reader.onerror = error => reject(error);
      })
      const attachmentData: AttachmentData = {
        Name: this.files[i].name as string,
        Path: undefined,
        Type: this.files[i].name.split(".").pop() as string,
        Content: content as ArrayBuffer,
        Size: `${Math.round(this.files[i].size / 1024)}KB`
      }
      this.attachmentsData.push(attachmentData);
    }
  }

  deleteFile(fileName: string) {
    for (let i = 0; i < this.attachmentsData.length; i++) {
      if (this.attachmentsData[i].Name == fileName) {
        this.attachmentsData.splice(i, 1);
      }
    }
  }

  receiveMessageEvent(message: Message) {
    if (message.IsBankMessage) {
      this.chatMessages.push(message)
      this.newCount++;
    }
    this.scrollToBottom()
  }

  receiveStatusEvent(message: Message) {
    const itemIndex: number = this.chatMessages.findIndex(
        (m: Message) => {
          if (m.Id == message.Id) return m;
        }
    );

    if(itemIndex >= 0) {
      this.chatMessages[itemIndex].Status = message.Status
    } else {
      this.chatMessages.push(message)
    }

    this.scrollToBottom()
  }

  /**
   * Сервис уведомлений
   * @returns {IAlertService}
   */
  get alertService(): IAlertService {
    return container.get<IAlertService>(DiTokens.AlertService);
  }


  /** Индикатор открытия чата */
  chatIsOpen: boolean = false

  /** Текст сообщения пользователя */
  messageText: string = ''

  subscribeFlag: boolean = true

  /**
   * Получние дом элемента контента чата
   * @returns {Element} - ссылка на дом объект чата.
   */
  get chatContent(): HTMLElement | null {
    return document.getElementById('content')
  }

  /** Открытие чата, запуск плагина для плавного скролла */
  openChat() {
    this.scrollToBottom();
    this.chatIsOpen = !this.chatIsOpen;

  }
  sendStatus() {
    this.chatMessages
        .filter((m: Message) => {
          return this.isNewMessage(m);
        })
        .forEach(async (m: Message) => {
          const oldStatus: MessageStatus = m.Status;
          m.Status = MessageStatus.Read;
          await callSignalRMethod(this.connection, "SendStatus", m);
        });
    this.newCount = 0;
  }

  isNewMessage(m: Message): boolean {
    return m.SenderType == 2 && m.Status != MessageStatus.Read;
  }
  /** Отправка сообщения пользователя и прокрутка чата вниз */
  async sendMessage() {
    if (this.messageText !== '') {
      await callSignalRMethod(this.connection, "SendMessage", this.createMessageObject(this.messageText, this.attachmentsData))
      this.scrollToBottom();
      this.messageText = '';
      this.attachmentsData = [];
    }
  }

  openImageInAnotherTab(image:string){
    var win = window.open();
    win.document.write('<iframe src="data:image/gif;base64,' + image  + '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>');
  }

  scrollToBottom(): void {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.timer = setTimeout(() => {
      this.chatContent?.scroll({ top: this.chatContent.scrollHeight + 500, left: 0, behavior: 'smooth' });
    }, 500);
  }

  createMessageObject(text: string, attachments: AttachmentData[]): Message {
    const msg: Message = {
      Id: undefined,
      Text: text,
      Status: MessageStatus.Sent,
      SenderType: SenderType.Client,
      CreatedAt: undefined,
      Attachments: attachments
    };

    return msg;
  }

  /** Подписка на получение сообщений чата, каждые 10 секунд */
  async loadMessages() {
    await getMessagesAction((chat: Message[]) => {
          this.chatMessages = chat;
          this.newCount = this.chatMessages.filter((m: Message) => {
            return m.SenderType == 2 && m.Status != MessageStatus.Read;
          }).length;
        },
        (err: string) => {
          this.alertService.error(err);
        });
  }
}